<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import moment from 'moment';

export default {
    page: {
        title: "Bookings",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: { Layout, PageHeader },

    data() {
		const datetime_now = moment().format("YYYY-MM-DD HH:mm:ss");
        return {
            title: "Bookings",
            items: [
                {
                    text: "bookings",
                    href: "/bookings",
                },  
                {
                    text: "Bookings",
                    active: true,
                },        
            ],
            pharmacy_bookings: [],
            keyword: "",
            type: "",
            listing_length: 10,
            pagination: {},
            
			now: datetime_now,
            modal_title: '',
            button_title: '',
            isEdit: false,
            patient_id: '',
            pharmacy_id: '',
            errors: {},
            patients: [],

            patient_visible: false,
            patient_keyword: '',
            is_priority: false,
            booking_date: moment().format('YYYY-MM-DD'),
            pharmacy_counters: [],
            counter_id: '',
            
            loading: false,
        }
    },
    mounted() {},
    created() {
        this.fetchBookings();
        this.fetchPatient();
        //this.fetchPharmacies();
    },
    methods: {
        fetchBookings(page_url = null) {
            this.getToken();
            let url = "api/admin/pharmacy/bookings?pharmacy_id=" + this.$route.params.id + "&limit=" + this.listing_length + "&status=" + this.type + "&keyword=" + this.keyword;
            page_url = page_url || url;

            if(localStorage.back_url) {
                page_url = localStorage.back_url;
                localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            this.$axios
                .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    this.pharmacy_bookings = responseData.bookings.data;
                    this.from = responseData.bookings.from;
                    this.to = responseData.bookings.to;
                    this.total = responseData.bookings.total;
                    this.pagination = responseData.bookings.links;
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            if (typeof error.response.data.message === 'object') {
                                console.log(error.response.status);
                            } else {
                                this.$swal("", error.response.data.message, "error");
                            }
                        }
                        else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
        },
       
          
        getToken() {
            if (localStorage.getItem('medicino_admin')) {
                var medicino_admin = JSON.parse(localStorage.getItem('medicino_admin'));
                if(medicino_admin.token) {
                    this.token = medicino_admin.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
            } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
            }
        },
        formatBookingDate(dateString) {
            const date = new Date(dateString);
            const day = date.getDate();
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
        },
        formatTime(time) {
            const formattedTime = new Date(`2002-02-02 ${time}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            return formattedTime;
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = date.getDate();
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
            const year = date.getFullYear();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            return `${day} ${month} ${year}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
        },

        handlePriorityChange(value) {
            if(value === true){
               this.fetchPharmacyCounters();
            }
         },

        fetchPharmacyCounters(){
            let url = "api/admin/pharmacy/counters?pharmacy_id=" + this.$route.params.id;
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.pharmacy_counters = responseData;
               })
               .catch((err) => console.log(err));
         },

        addBookingModal() {
            this.modal_title = 'Add Booking';
            this.button_title = 'Save';
            this.isEdit = false;
            this.clearForm();
            this.$refs['booking-modal'].show();
        },

         addBooking(){
            this.errors = {};
            
            
            this.loading = true;
            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/pharmacy/addBooking";

            let formData = new FormData();
            formData.append("pharmacy_id", this.$route.params.id);
            formData.append("patient_id", this.patient_id);
            formData.append("booking_date", this.booking_date);
            formData.append("is_priority", this.is_priority);
            formData.append("counter_id", this.counter_id);

            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status === 'true' || response.data.status === true) {
                     this.hideModal('booking-modal');
                     this.$swal({
                        title: "Success!",
                        text: response.data.message || "Booking created successfully",
                        icon: "success",
                        confirmButtonText: "OK"
                                           }).then(() => {
                         this.fetchBookings();
                         this.clearForm();
                      });
                  } else {
                     this.$swal("Error", response.data.message || "Failed to create booking", "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422){
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                     } else {
                        this.$swal("Error", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("Error", "Network error. Please try again.", "error");
                  }
               })
               .finally(() => {
                  this.loading = false;
               });
         },

         clearForm() {
            this.patient_id = '';
            this.pharmacy_id = '';
            this.patient_visible = false;
            this.patient_keyword = '';
            this.counter_id = '';
            this.is_priority =  false;
        },

        fetchPatient() { 
            let url = "api/fetchPatients";
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.patients = responseData.patients;
                  
               })
               .catch((err) => console.log(err));
            
         },

         //fetchPharmacies() {
         //   let url = "api/admin/pharmacy/getPharmacies";        
         //   this.getToken();
         //   this.$axios
         //      .get(url, { headers: { Authorization: "Bearer " + this.token } })
         //      .then((res) => {
         //         var responseData = res.data.data;
         //         console.log(responseData);
         //         this.pharmacies = responseData.pharmacies || [];
         //      })
         //      .catch((err) => console.log(err));
         //},

        hideModal(modalRef) {
            this.$refs[modalRef].hide();
        },

    
    fetchPatients() {
        //if (!this.patient_keyword) {
         //   this.patients = [];
         //   this.patient_visible = false;
         //   return;
        //}
        let url = "api/admin/pharmacy/orders/getpatients?keyword=" + this.patient_keyword;
        this.getToken();
        this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                var responseData = res.data.data;
                this.patients = responseData.patients;
                this.patient_visible = true;
                // Focus the input after DOM update
                     this.$nextTick(() => {
                        this.$refs.patientInput?.focus();
                     });
            })
            .catch(() => {
                this.patients = [];
                this.patient_visible = true;
            });
    },

    setPatient()
    {
        const selected = this.patients.find(p => p.patient_id === this.patient_id);
        if (selected) {
            this.patient_keyword = selected.name;
        }
        this.patient_visible = false;
    },
    onClickOutside() {
        if (!this.patient_id) {
            this.patient_keyword = '';
        }
        this.patient_visible = false;
    },
    closePatientSearch() {
        this.patient_visible = false;
        this.patient_keyword = '';
        this.patient_id = '';
    },
    },
}
</script>


<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">

                 <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                      <b-button v-b-modal.booking-modal variant="primary" class="float-end" @click="addBookingModal()">Add Booking</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

					<!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacies' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
						
					<!----- Listing length and search starts ----->
					<div class="row mb-3">
						<div class="col-sm-12 col-md-6">
							<div class="listing-length" >
								<label
								>Show
								<select class="form-control" v-model="listing_length" @change = "fetchBookings()">
									<option value="5">5</option>
									<option value="10">10</option>
									<option value="15">15</option>
								</select>
								entries
								</label>
							</div>                        
						</div>
						<div class="col-sm-12 col-md-6">
							<div class="listing-filter">
								<label>
									<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup = "fetchBookings()"/>
								</label>
							</div>                     
							<div class="listing-filter me-2">
								<label>
								<select class="form-control" v-model="type" @change = "fetchBookings()">
									<option value="">All</option>
                                    <option value="1">Pending</option>
                                    <option value="2">Completed</option>
								</select>
								</label>
							</div>   
						</div>
					</div>
					<!----- Listing length and search ends ----->
	
					<!---- listing table starts -------->
					<div class="table-responsive">
						<table class="table table-bordered mb-0">
	
							<thead class="table-light">
								<tr>
                                <th>Booking Date</th>
                                <th>Token</th>
                                <th>Counter</th>
                                <th>Status</th>
                                <th>Called On</th>
                                <th>Created On</th>
								</tr>
							</thead>
							<tbody v-if="Boolean(pharmacy_bookings.length)">
								<tr v-for="pharmacy_booking in pharmacy_bookings" :key="pharmacy_booking.id">
									<td>{{ formatBookingDate(pharmacy_booking.booking_date) }}</td>
                                    <td>{{ pharmacy_booking.token }}</td>
                                    <td><span v-if="pharmacy_booking.counter_id"> {{ pharmacy_booking.counter_name }}</span></td>
                                    <td>
                                        <p class="badge bg-success" v-if="pharmacy_booking.status==1">Pending</p>
                                        <p class="badge bg-warning"  v-if="pharmacy_booking.status==2">Completed</p>
                                        <p  v-if="pharmacy_booking.status==3" class="badge bg-info">No Show<br></p>
                                        <p class="badge bg-danger" v-if="pharmacy_booking.status==4">Cancelled</p>
									</td>
                                    <td><span v-if="pharmacy_booking.called_at">{{ formatDate(pharmacy_booking.called_at) }}</span></td>
									
									
									<td>{{ formatDate(pharmacy_booking.created_at) }}</td>
								</tr>

								
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="5" class="text-center">No bookings found</td>
								</tr>
							</tbody>

						</table>
					</div>
					<!---- listing table ends -------->
	
					<!----pagination starts ---> 
					<caption v-if="Boolean(pharmacy_bookings.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
					<ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
						<li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
							<a href="#" class="page-link" @click.prevent="fetchBookings(page.url + '&pharmacy_id='+ $route.params.id + '&limit='+ listing_length + '&status=' + type + '&keyword=' + keyword)">
							<i v-if="index == 0" class="mdi mdi-chevron-left"></i>
							<i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
							<span v-else>{{page.label}}</span>                          
							</a>
						</li>
					</ul>
					<!----pagination ends --->
					</div>
				</div>
			</div>

            

            <b-modal ref="booking-modal" id="booking-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                <b-form @submit.prevent="addBooking">
                    <div class="row">
                        <div class="form-group col-md-6" v-click-outside="onClickOutside">
                            <label>Patient <span class="text-danger">*</span></label>
                            <div class="search-select position-relative">
                                <span class="search-close" v-if="patient_visible" @click="closePatientSearch" style="position: absolute; right: 10px; top: 10px; z-index: 10;">
                                    <i class="dripicons dripicons-cross"></i>
                                </span>
                                <b-form-input
                                    ref="patientInput"
                                    v-model="patient_keyword"
                                   @keyup="fetchPatients" 
                                   @click="fetchPatients"
                                    autocomplete="off"
                                    placeholder="Search here..."
                                    :class="{ 'is-invalid': Boolean(errors.patient_id) }"
                                ></b-form-input>
                                <b-form-select
                                    class="form-control mt-1"
                                    v-if="patient_visible && patients.length"
                                    v-model="patient_id"
                                    :select-size="patients.length < 10 ? (patients.length <= 1 ? 2 : patients.length) : 10"
                                    @change="setPatient"
                                >
                                    <b-form-select-option
                                        v-for="patient in patients"
                                        :key="patient.patient_id"
                                        :value="patient.patient_id"
                                    >
                                        {{patient.country_code}} {{patient.mobile}} | {{ patient.name }}
                                    </b-form-select-option>
                                </b-form-select>
                                <b-form-select
                                    class="form-control mt-1"
                                    v-if="patient_visible && !patients.length"
                                    v-model="patient_id"
                                    :select-size="2"
                                >
                                    <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                </b-form-select>
                            </div>
                            <div v-for="(val, index) in errors.patient_id" :key="index" class="invalid-feedback">
                                <p class="mb-0">{{ val }}</p>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Booking Date <span class="text-danger">*</span></label>
                            <input type="date" class="form-control" v-model="booking_date" readonly />
                        </div>
                    </div>
                     <div class="row">
                      <b-col md="6"  class="form-group" >
                                 <label>Is Priority <span class="text-danger">*</span></label>
                                 <b-form-radio-group v-model="is_priority" @change="handlePriorityChange" v-bind:class="{ 'is-invalid': Boolean(errors.is_priority) }">
                                    <div class="d-flex gap-4">
                                       <b-form-radio :value="true">Yes</b-form-radio>
                                       <b-form-radio :value="false">No</b-form-radio>
                                    </div>
                                 </b-form-radio-group>
                                 <div v-for="(val, index) in errors.is_priority" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>
                              <b-col md="6"  class="form-group" v-if="is_priority == true">
                                 <label>Counter <span class="text-danger">*</span></label>
                                 <select class="form-control" v-model="counter_id" v-bind:class="{ 'is-invalid': Boolean(errors.counter_id) }">
                                    <option value="">Select Counter</option>
                                    <option :value="counter.id" v-for="counter in pharmacy_counters" :key="counter.id">{{counter.counter_name}}</option>
                                 </select>
                                 <div v-for="(val, index) in errors.counter_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 text-end">
                            <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                                <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                {{ loading ? 'Saving...' : button_title }}
                            </b-button>
                            <b-button variant="light" @click="hideModal('booking-modal')" :disabled="loading">Close</b-button>
                        </div>
                    </div>
                </b-form>
            </b-modal>


		</div>
	</Layout>
</template>
